<template>
  <v-container fluid>
    <v-card flat>
      <v-card-text>
        <v-stepper v-model="formStep">
          <v-stepper-header>
            <v-stepper-step
              step="1"
              :complete="formStep > 1"
              editable
            >
              User Info
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
              step="2"
              :complete="formStep > 2"
              editable
            >
              Login Info
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
              step="3"
              :complete="formStep > 3"
              editable
            >
              Company Info
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
              step="4"
              editable
            >
              Exam
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-container fluid class="px-1" style="max-width: 500px">
                <v-card flat>
                  <v-card-text class="px-0">
                    <v-text-field
                      v-model="form.fullName"
                      name="fullName"
                      label="Full Name"
                      type="text"
                      append-icon="mdi-account"
                      solo
                      :rules="[rules.required]"
                      @change="handleFormChange()"
                    ></v-text-field>

                    <v-text-field
                      v-model="form.email"
                      name="email"
                      label="E-mail"
                      type="text"
                      append-icon="mdi-email"
                      solo
                      :rules="[rules.required, rules.email]"
                      @change="handleFormChange('email')"
                    ></v-text-field>

                    <v-text-field
                      v-model="form.phone"
                      name="phone"
                      label="Phone"
                      type="text"
                      append-icon="mdi-phone"
                      solo
                      @change="handleFormChange()"
                    ></v-text-field>
                  </v-card-text>
                </v-card>
              </v-container>

              <v-btn
                color="primary"
                @click="formStep = 2"
              >
                Continue
              </v-btn>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-container fluid class="px-1" style="max-width: 500px">
                <v-card flat>
                  <v-card-text class="px-0">
                    <v-text-field
                      v-model="form.username"
                      name="username"
                      label="Username"
                      type="text"
                      append-icon="mdi-account-circle"
                      solo
                      :rules="[rules.required, rules.nospace]"
                      @change="handleFormChange('username')"
                    ></v-text-field>

                    <v-text-field
                      v-model="form.password"
                      name="password"
                      label="Password"
                      :type="showPassword ? 'text' : 'password'"
                      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                      solo
                      hint="Minimum of 8 characters with at least 1 uppercase, 1 number and 1 special character (!&@#$%)"
                      @click:append="showPassword = !showPassword"
                      :rules="[rules.required, rules.uppercase, rules.number, rules.special, rules.min8]"
                      @change="handleFormChange()"
                    ></v-text-field>
                  </v-card-text>
                </v-card>
              </v-container>

              <v-btn
                color="primary"
                @click="formStep = 3"
              >
                Continue
              </v-btn>
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-container fluid class="px-1" style="max-width: 500px">
                <v-card flat>
                  <v-card-text class="px-0">
                    <v-text-field
                      v-model="form.companyName"
                      name="companyName"
                      label="Company Name"
                      type="text"
                      append-icon="mdi-office-building"
                      solo
                      :rules="[rules.required]"
                      @change="handleFormChange()"
                    ></v-text-field>

                    <v-select
                      v-model="form.role"
                      name="role"
                      label="Role"
                      :items="roles"
                      solo
                      @change="handleFormChange()"
                    ></v-select>
                  </v-card-text>
                </v-card>
              </v-container>

              <v-btn
                color="primary"
                @click="formStep = 4"
              >
                Continue
              </v-btn>
            </v-stepper-content>

            <v-stepper-content class="pa-0" step="4">
              <v-container fluid>
                <v-stepper
                  v-model="examStep"
                  vertical
                  class="elevation-0 pb-0"
                >
                  <div
                    v-for="(item, index) in exam"
                    :key="index"
                  >
                    <v-stepper-step
                      :complete="examStep > index + 1"
                      :step="index + 1"
                      :rules="[() => !item.incorrect]"
                      editable
                    >
                      {{ item.question }}
                    </v-stepper-step>

                    <v-stepper-content :step="index + 1">
                      <v-card flat>
                        <v-card-text class="pt-0">
                          <v-radio-group v-model="item.response">
                            <v-radio
                              v-if="item.a"
                              :label="item.a"
                              value="a"
                              @click="handleExamChange()"
                            ></v-radio>
                            <v-radio
                              v-if="item.b"
                              :label="item.b"
                              value="b"
                              @click="handleExamChange()"
                            ></v-radio>
                            <v-radio
                              v-if="item.c"
                              :label="item.c"
                              value="c"
                              @click="handleExamChange()"
                            ></v-radio>
                            <v-radio
                              v-if="item.d"
                              :label="item.d"
                              value="d"
                              @click="handleExamChange()"
                            ></v-radio>
                          </v-radio-group>
                        </v-card-text>

                        <v-card-actions>
                          <v-btn
                            color="primary"
                            @click="handleExamContinue()"
                          >
                            Continue
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-stepper-content>
                  </div>

                  <v-row no-gutters>
                    <v-spacer></v-spacer>
                      <v-btn
                        v-if="false"
                        class="mt-4 mr-6"
                        color="primary"
                        @click="autoFormComplete()"
                      >
                        Auto-Complete
                      </v-btn>

                      <v-btn
                      class="mt-4 mr-6"
                      color="primary"
                      :disabled="!examComplete || !formComplete"
                      @click="handleSubmit()"
                    >
                      Submit
                    </v-btn>
                  </v-row>
                </v-stepper>
              </v-container>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card-text>
    </v-card>

    <v-dialog
      v-model="dialogComplete"
      width="500px"
      loading
      persistent
    >
      <v-card>
        <template slot="progress">
          <v-progress-linear
            color="success"
            indeterminate
          ></v-progress-linear>
        </template>

        <v-card-text class=" success pa-6 pb-1">
          <p class="text-h5 white--text">
            <strong>Success!</strong> Your exam has been submitted successfully. 
          </p>
          <p class="subtitle-1 white--text">
            Please allow 1-2 business days to process your exam. You will be sent a confirmation email upon approval.
          </p>
        </v-card-text>

        <v-card-actions class="success">
          <v-spacer></v-spacer>
          <v-btn
            color="white"
            plain
            large
            @click="goToLogin()"
          >
            Go to Login
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import UserExamService from "../../services/userExam.service"
import AuthService from "../../services/auth.service"

export default {
  name: 'NewUser',
  data() {
    return {
      formStep: 1,
      roles: ['Administrator', 'Technician'],
      form: {
        fullName: '',
        email: '',
        phone: '',
        username: '',
        password: '',
        companyName: '',
        role: '',
        attemptCount: 0
      },
      showPassword: false,
      formComplete: false,
      examStep: 1,
      exam: [
        {
          question: 'How often does the Lab On Locale need to be sent to X-zam Labs for calibration?',
          a: 'Quarterly',
          b: 'Yearly',
          c: 'Monthly',
          d: 'Semi-annually',
          answer: 'b',
          response: null,
        },
        {
          question: 'True or False: The Filter Disks in the Oil/Particle Tester can be reused for more than one sample.',
          a: 'True',
          b: 'False',
          answer: 'b',
          response: null
        },
        {
          question: 'What should be used to handle the Oil/Particle Filter Disk?',
          a: 'My fingers',
          b: 'Gloves',
          c: 'A paper clip',
          d: 'Tweezers',
          answer: 'd',
          response: null,
        },
        {
          question: 'How often do validations need to be done on the Lab On Locale?',
          a: 'Yearly',
          b: 'Quarterly',
          c: 'Monthly',
          d: 'Weekly',
          answer: 'b',
          response: null,
        },
        {
          question: 'True or False: Authorized Users cannot run accredited tests if they do not meet their validation or calibration requirements.',
          a: 'True',
          b: 'False',
          answer: 'a',
          response: null,
        },
        {
          question: 'Who can operate the Lab On Locale Portable device?',
          a: 'A customer',
          b: 'A certified user',
          c: 'A service technician',
          d: 'Anyone with access to the unit',
          answer: 'b',
          response: null,
        },
        {
          question: 'When does the Lab On Locale Portable perform a sync?',
          a: 'On start up',
          b: 'When starting a test',
          c: 'When submitting a test',
          d: 'All of the above',
          answer: 'd',
          response: null,
        },
        {
          question: 'True or False: Client information can be added from both the web portal and the tablet portal.',
          a: 'True',
          b: 'False',
          answer: 'a',
          response: null,
        },
        {
          question: 'What information is required to perform a test?',
          a: 'Client information',
          b: 'Location information',
          c: 'Air source information',
          d: 'All of the above',
          answer: 'd',
          response: null,
        },
        {
          question: 'What is the maximum inlet pressure going into the LOL Portable?',
          a: '60 PSI',
          b: '130 PSI',
          c: '100 PSI',
          d: '200 PSI',
          answer: 'b',
          response: null,
        },
        {
          question: 'When should the OVA valve be closed?',
          a: 'When the Oil Vapor test gauge reaches 100%',
          b: 'When the Water Vapor test gauge reaches 100%',
          c: 'When the Gas and Particles Gauge reach 100%',
          d: 'All of the above',
          answer: 'a',
          response: null,
        },
        {
          question: 'If a test is successfully stored locally but has not been synced to X-zam Labs it will appear in...',
          a: 'Pending Approvals',
          b: 'Pending Sync',
          c: 'Approved This Week',
          d: 'None of the above',
          answer: 'b',
          response: null,
        },
        {
          question: 'If a test is successfully stored locally and has synced with X-zam Labs it will appear in...',
          a: 'Pending Approvals',
          b: 'Pending Sync',
          c: 'Approved This Week',
          d: 'None of the above',
          answer: 'a',
          response: null,
        },
        {
          question: 'True or False: The Lab On Locale Portable should be turned off when traveling between testing locations?',
          a: 'True',
          b: 'False',
          answer: 'a',
          response: null,
        },
        {
          question: 'Where can you view your certificates?',
          a: "From the web portal's 'Certificates' tab",
          b: "From the web portal's 'Clients' tab",
          c: "From the web portal's 'LOLs' tab",
          d: 'None of the above',
          answer: 'a',
          response: null,
        },
        {
          question: 'How long is the user certification certificate valid for?',
          a: '1 year',
          b: '6 months',
          c: '2 years',
          d: '3 years',
          answer: 'a',
          response: null,
        },
        {
          question: 'Who can replace a validation canister?',
          a: 'A customer',
          b: 'A certified user',
          c: 'A service technician',
          d: 'Anyone with access to the unit',
          answer: 'b',
          response: null,
        },
        {
          question: 'Where can you create, add, or modify client information?',
          a: 'On the clients tab of the web portal',
          b: 'On the clients tab of the tablet portal',
          c: 'During a test, when prompted to select customer information',
          d: 'All of the above',
          answer: 'd',
          response: null,
        },
        {
          question: 'What equipment is to be used to ensure the air pressure is properly regulated for use with the Lab On Locale Portable?',
          a: 'The regulator assemblies provided by X-zam Labs',
          b: 'Any regulating device which will regulate to 100 PSI',
          c: 'You do not have to regulate the air pressure going to the LOL unit',
          d: 'All of the above',
          answer: 'a',
          response: null,
        },
        {
          question: 'To which email will test results be sent?',
          a: "The certified user's email",
          b: "The client's email",
          c: "The company's email",
          d: "Results will not be sent via email",
          answer: 'a',
          response: null,
        },
      ],
      examComplete: false,
      dialogComplete: false,
      rules: {
        required: v => v.length != 0 || 'Required',
        nospace: v => !v.includes(' ') || 'Spaces not allowed',
        min8: v => v.length > 8 || 'Minimum 8 characters',
        uppercase: v => /(?=.*[A-Z])/.test(v) || 'Must have at least one uppercase character',
        number: v => /(?=.*\d)/.test(v) || 'Must have at least one number',
        special: v => /([!&@#$%])/.test(v) || 'Must have at least one special character (!&@#$%)',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail'
        },
      },
    }
  },

  computed: {},

  created() {},

  methods: {
    handleFormChange(field) {
      if (field == 'username') {
        AuthService.findByUsernameLimited(this.form.username)
          .then(response => {
            if (response.data.length) {
              this.form.username = ''
              this.snackbar('Error! Username already taken', 'error')
            }
          })
        .catch(e => {
          console.log(e)
        })
      }

      if (field == 'email') {
        AuthService.findByEmailLimited(this.form.email)
          .then(response => {
            if (response.data.length) {
              this.form.email = ''
              this.snackbar('Error! Email already taken', 'error')
            }
          })
        .catch(e => {
          console.log(e)
        })
      }

      for (const item in this.form) {
        if (!this.form[item] && item != 'attemptCount') {
          this.formComplete = false
          return
        }
      }
      this.formComplete = true
    },

    handleExamChange() {
      for (const item of this.exam) {
        if (!item.response) {
          this.examComplete = false
          return
        }
      }
      this.examComplete = true
    },

    handleExamContinue() {
      this.examStep++
    },

    autoFormComplete() {
      this.form = {
        fullName: 'fullName',
        email: 'email@email.com',
        phone: '1234567890',
        username: 'username',
        password: 'password',
        companyName: 'companyName',
        role: 'Administrator',
        attemptCount: 0
      }

      for (const item of this.exam) {
        item.response = 'a'
      }

      this.handleFormChange()
      this.handleExamChange()
    },

    handleSubmit() {
      this.form.attemptCount++
      console.log(this.form)
      this.form.responses = ''
      this.form.answers = ''
      var incorrectCount = 0
      var firstIncorrectIndex = null

      for (const item of this.exam) {
        if (item.response != item.answer) {
          item.incorrect = true
          incorrectCount++
          if (!firstIncorrectIndex) {
            firstIncorrectIndex = this.exam.indexOf(item)
          }
        } else {
          item.incorrect = false
        }
        this.form.responses += `${item.response};`
        this.form.answers += `${item.answer};`
      }

      if (incorrectCount > 0) {
        this.snackbar(`Sorry! You had ${incorrectCount} wrong answers`, 'error')
        this.examStep = firstIncorrectIndex + 1
        return
      }

      UserExamService.create(this.form)
        .then(response => {
          this.dialogComplete = true
          setTimeout(() => { this.$router.push('/login') }, 10000);
          // this.snackbar('Success! The user exam was submitted successfully','success')
        })
        .catch(e => {
          console.log(e)
          this.snackbar('Error! There was an error submitting the user exam', 'error')
        })
    },

    goToLogin() {
      this.$router.push('/login')
    },

    snackbar(message, color, timeout) {
      window._LOL2P.$emit('SHOW_SNACKBAR', {
        text: message,
        color: color,
        timeout: timeout
      })
    },
  }
}
</script>

<style>
@media only screen and (max-width: 959px) {
  .v-stepper--vertical .v-stepper__label {
    display: flex !important;
  }

  .v-stepper__step__step {
    margin-right: 12px !important;
  }
}
</style>
